import { createFileRoute } from '@tanstack/react-router'
import { GlossaryTermPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'

export const Route = createFileRoute('/de/glossar/$termSlug')({
  loader: ({ params }) =>
    loadPageData({ data: { kind: 'glossaryTerm', locale: 'de', params } }),
  head: ({ loaderData }) => loaderData?.head ?? {},
  component: RouteComponent,
})

function RouteComponent() {
  const { termSlug } = Route.useParams()
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <GlossaryTermPage termSlug={termSlug} />
    </CatalogProvider>
  )
}
